const steps = [
  {
    num: '01',
    icon: 'ri-search-eye-line',
    title: 'Диагностика',
    desc: 'Анализ текущей ситуации: аудит процессов обучения, оценка компетенций ключевых сотрудников, интервью с руководителями, выявление потребностей бизнеса. Формируем объективную картину — с чем работаем и куда хотим прийти.',
  },
  {
    num: '02',
    icon: 'ri-file-list-3-line',
    title: 'Описание компетенций',
    desc: 'Создаём матрицу компетенций для каждой роли. Определяем, какие знания, навыки и модели поведения необходимы на каждом уровне — от новичка до руководителя. Это фундамент всей системы.',
  },
  {
    num: '03',
    icon: 'ri-pencil-ruler-2-line',
    title: 'Проектирование системы',
    desc: 'Разрабатываем архитектуру корпоративной академии: образовательные треки, форматы обучения, систему оценки, базу знаний. Проектируем процессы наставничества и развития внутренних тренеров.',
  },
  {
    num: '04',
    icon: 'ri-file-text-line',
    title: 'Создание программ',
    desc: 'Разрабатываем содержание: тренинги, бизнес-игры, кейсы, видеоуроки, чек-листы, тесты. Все материалы создаются под специфику вашей компании и привязаны к матрице компетенций.',
  },
  {
    num: '05',
    icon: 'ri-user-voice-line',
    title: 'Подготовка внутренних тренеров',
    desc: 'Отбираем сотрудников с потенциалом, обучаем их методике преподавания, публичным выступлениям и коучинговому подходу. Компания получает собственный тренерский состав.',
  },
  {
    num: '06',
    icon: 'ri-rocket-2-line',
    title: 'Запуск',
    desc: 'Пилотный запуск на одном направлении (обычно онбординг или отдел продаж). Собираем обратную связь, корректируем программы, готовимся к масштабированию.',
  },
  {
    num: '07',
    icon: 'ri-heart-pulse-line',
    title: 'Сопровождение',
    desc: 'Регулярные посттренинговые встречи, коучинговые сессии, поддержка наставников. Помогаем внедрить изменения в ежедневную работу и преодолеть сопротивление.',
  },
  {
    num: '08',
    icon: 'ri-loop-left-line',
    title: 'Развитие академии',
    desc: 'Анализируем результаты, обновляем программы, повышаем уровень сложности, добавляем новые направления. Академия эволюционирует вместе с бизнесом.',
  },
];

export default function ImplementationProcess() {
  return (
    <section id="implementation" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Как внедряется корпоративная академия
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Поэтапный подход от диагностики до полномасштабной системы обучения. Каждый этап приносит измеримые результаты.
        </p>

        <div className="relative">
          {/* Vertical line for desktop */}
          <div className="hidden lg:block absolute left-8 top-0 bottom-0 w-1 bg-teal-200 rounded-full"></div>

          <div className="space-y-8">
            {steps.map((step, i) => (
              <div key={i} className="relative flex gap-6 lg:gap-10">
                {/* Number circle */}
                <div className="relative z-10 flex-shrink-0">
                  <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center ring-4 ring-white">
                    <span className="text-white font-extrabold text-lg">{step.num}</span>
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1 bg-gray-50 rounded-xl p-6 md:p-8 border border-gray-200 hover:border-teal-300 transition-all pt-4 lg:pt-6">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center lg:hidden">
                      <i className={`${step.icon} text-teal-600`}></i>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900">{step.title}</h3>
                  </div>
                  <p className="text-gray-600 leading-relaxed text-sm md:text-base">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}